import { render, staticRenderFns } from "./PancreasIslets.vue?vue&type=template&id=2fc79670&"
import script from "./PancreasIslets.vue?vue&type=script&lang=ts&"
export * from "./PancreasIslets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports